export const SERIES = [
    { name: 'E-commerce', color: '#3B82F6' },
    { name: 'ERP', color: '#64748B' }
]
const SERIES_COLOR = { ecommerce: SERIES[0].color, erp: SERIES[1].color }

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const monthLabel = (syncDate) => MONTHS[Number(String(syncDate).slice(5, 7)) - 1] || ''

const num = (value) => Number(value) || 0

const successful = (count, errors) => Math.max(count - errors, 0)

const accuracy = (count, errors) => (count > 0 ? (successful(count, errors) / count) * 100 : 0)

const sum = (values) => values.reduce((total, value) => total + value, 0)

export const buildKeyMetrics = (summary = []) => {
    const rows = [...summary]
        .sort((a, b) => String(a.syncDate).localeCompare(String(b.syncDate)))
        .map((row) => ({
            month: monthLabel(row.syncDate),
            ecommerce: num(row.eCommerceCount),
            ecommerceErrors: num(row.eCommerceErrorCount),
            erp: num(row.erpCount),
            erpErrors: num(row.erpErrorCount)
        }))
    const labels = rows.map((row) => row.month)

    const recordTotal = sum(rows.map((row) => row.ecommerce + row.erp))
    const errorTotal = sum(rows.map((row) => row.ecommerceErrors + row.erpErrors))
    const successTotal = sum(rows.map((row) => successful(row.ecommerce, row.ecommerceErrors) + successful(row.erp, row.erpErrors)))

    return [
        {
            key: 'records',
            icon: 'uil-sync',
            title: 'Record Count',
            value: recordTotal.toLocaleString(),
            labels,
            series: [
                { name: 'E-commerce', color: SERIES_COLOR.ecommerce, values: rows.map((row) => row.ecommerce) },
                { name: 'ERP', color: SERIES_COLOR.erp, values: rows.map((row) => row.erp) }
            ]
        },
        {
            key: 'errors',
            tone: errorTotal > 0 ? 'warning' : undefined,
            icon: 'uil-exclamation-triangle',
            title: 'Critical Error Count',
            value: errorTotal.toLocaleString(),
            labels,
            series: [
                { name: 'E-commerce', color: SERIES_COLOR.ecommerce, values: rows.map((row) => row.ecommerceErrors) },
                { name: 'ERP', color: SERIES_COLOR.erp, values: rows.map((row) => row.erpErrors) }
            ]
        },
        {
            key: 'accuracy',
            icon: 'uil-check-circle',
            title: 'Accuracy Rate',
            value: `${(recordTotal > 0 ? (successTotal / recordTotal) * 100 : 0).toFixed(2)}%`,
            labels,
            unit: '%',
            series: [
                { name: 'E-commerce', color: SERIES_COLOR.ecommerce, values: rows.map((row) => accuracy(row.ecommerce, row.ecommerceErrors)) },
                { name: 'ERP', color: SERIES_COLOR.erp, values: rows.map((row) => accuracy(row.erp, row.erpErrors)) }
            ]
        }
    ]
}
